import { Component, inject } from '@angular/core';

import { AuthService } from "../../auth/auth.service";
import { SessionService } from '../../services/session.service';

@Component({
  selector: 'user-login',
  templateUrl: './user-login.component.html',
  host: {
    'class': 'flex flex-grow'
  },
  standalone: false
})
export class UserLoginComponent {
  session = inject(SessionService);
  public accountName: string = '';
  public password: string = '';
  public remember: boolean = false;

  constructor (private authService: AuthService) { };

  async onSubmit () {
    try {
      await this.authService.login(this.accountName, this.password, this.remember);
    }
    catch (error) {
      console.log('error:', error);
      this.session.setErrorMessage("account and password did not match.");
      window.scrollTo({
        behavior: 'smooth',
        top: 0,
      });
    }
  };
};
